import { BeforeProcessEndEventPayload } from '@mwe/features/wizard';
import { map, Observable, of, take, tap } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { PopupService } from '@mwe/services';
import { Router } from '@angular/router';
import { ROUTE_UMMELDUNG_BESTAETIGUNG, ROUTE_UMMELDUNG_FILE_UPLOAD } from '../../../app.constants';
import { UmmeldungWizardService } from '../ummeldung.wizard.service';
import { mapExitPopupResultToDecision, UMMELDUNG_EXIT_POPUP_RESULT, UmmeldungExitPopupDecision } from './exit-popup-decision';
import { UMMELDUNG_EXIT_POPUP, UMMELDUNG_INVALID_EXIT_POPUP } from '../../../config/popup/ummeldung-popup.config';

/**
 * Hook for `withConfirmExit`. Contract of the returned observable: emit `true` to PREVENT the
 * exit (stay in the wizard), `false` to allow it.
 */
function ummeldungCustomConfirmExitDialog(event: BeforeProcessEndEventPayload): Observable<boolean> {
  const ummeldungWizardService = inject(UmmeldungWizardService);
  if (event.reason === 'finished') {
    return of(false);
  }
  if (ummeldungWizardService.consumeNextExitConfirmationBypass()) {
    return of(false);
  }
  if (inject(Router).url.includes(ROUTE_UMMELDUNG_BESTAETIGUNG) || inject(Router).url.includes(ROUTE_UMMELDUNG_FILE_UPLOAD)) {
    return of(false);
  }

  const exitPopupType = ummeldungWizardService.touchAndValidateCurrentStep() ? 'default' : 'invalid';
  openUmmeldungExitPopup(exitPopupType);
  return observeExitPopupDecision().pipe(map(decision => decision === UMMELDUNG_EXIT_POPUP_RESULT.stay));
}

function closeWithCustomConfirmExitDialog(): Observable<UmmeldungExitPopupDecision> {
  const ummeldungWizardService = inject(UmmeldungWizardService);

  const exitPopupType = ummeldungWizardService.touchAndValidateCurrentStep() ? 'default' : 'invalid';
  openUmmeldungExitPopup(exitPopupType);

  return observeExitPopupDecision().pipe(
    tap(decision => {
      if (decision !== UMMELDUNG_EXIT_POPUP_RESULT.stay) {
        ummeldungWizardService.closeWithoutExitConfirmation();
      }
    }),
  );
}

function observeExitPopupDecision(): Observable<UmmeldungExitPopupDecision> {
  return inject(PopupService).events().pipe(take(1), map(mapExitPopupResultToDecision));
}

function openUmmeldungExitPopup(exitPopupType: 'default' | 'invalid' = 'default'): void {
  const popupService = inject(PopupService);

  if (exitPopupType === 'invalid') {
    popupService.open({
      ...UMMELDUNG_INVALID_EXIT_POPUP,
      useCustomReturnValue: true,
      subscriptionId: UMMELDUNG_EXIT_POPUP_RESULT.discardAndExit,
    });
    return;
  }

  popupService.openV2({ ...UMMELDUNG_EXIT_POPUP, modalOpts: { injector: inject(Injector) } });
}

export { ummeldungCustomConfirmExitDialog, closeWithCustomConfirmExitDialog };
